import axios from 'axios';
import React, { useEffect, useState } from 'react';
import * as CONST from "../../../component/config/Constant";
import { Helmet } from "react-helmet";
import { FiMessageSquare } from "react-icons/fi";
import { BsQuote } from "react-icons/bs";
import "../../../assets/css/home.css";

function WebTestimonials() {
  const [testimonials, setTestimonials] = useState("");

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    await axios.get(CONST.TESTIMONIAL_LIST, { page_number: 1, limit: 50 })
      .then((response) => {
        if (response.data.status === 'success') setTestimonials(response.data.data);
      })
      .catch((error) => console.log(error));
  }

  return (
    <>
      <Helmet><title>Testimonials | HRD Portal - eLuminous Technologies</title></Helmet>

      <section className="testimonials-page-hero">
        <div className="container">
          <div className="testimonials-hero-row">
            <div className="testimonials-hero-icon"><FiMessageSquare /></div>
            <div>
              <h1 className="testimonials-hero-title">Employee Testimonials</h1>
              <p className="testimonials-hero-sub">What our team members say about working at eLuminous</p>
            </div>
          </div>
        </div>
      </section>

      <section className="testimonials-page-list">
        <div className="container">
          <div className="row">
            {testimonials && testimonials.map((testimonial, index) => {
              let desc = testimonial.description.replace(/(<([^>]+)>)/ig, '').replace('&nbsp;', ' ');
              return (
                <div className="col-lg-4 col-md-6 mb-4" key={index}>
                  <div className="testimonial-page-card">
                    <div className="testimonial-page-quote"><BsQuote /></div>
                    <p className="testimonial-page-text">{desc}</p>
                    <div className="testimonial-page-author">
                      <div className="testimonial-page-avatar">
                        {testimonial.user && (
                          testimonial.user.profile_photo_path ? (
                            <img src={CONST.HOST + testimonial.user.profile_photo_path} alt="" />
                          ) : (
                            <span className="testimonial-page-initials">
                              {testimonial.user.first_name?.[0]}{testimonial.user.last_name?.[0]}
                            </span>
                          )
                        )}
                      </div>
                      <div>
                        <div className="testimonial-page-name">
                          {testimonial.user?.first_name} {testimonial.user?.last_name}
                        </div>
                        <div className="testimonial-page-dept">
                          {testimonial.user?.department?.name}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  )
}

export default WebTestimonials
